export default __webpack_public_path__ + "static/media/debate_club.be908652.png";